/**
 * @module events/types/touchEnd
 */

/**
 * @type {string}
 */
export default 'touchend'
